module.exports = __webpack_public_path__ + "17a8910a41baf5f0b0f7d083e5fafe33.png";